import Helper from './Helper';
import InteractiveMapAccordion from './InteractiveMapAccordion';
import Swiper from "../lib/swiper";

class InteractiveMap {
  constructor(config = {}) {
    const {
      urlPart,
      urlPartCategories,
      categoriesName,
      mapClass,
      filterContainer,
      svgElements,
      filterTitelClass,
      mapTitle,
      mapInfo,
      tableHeadClass,
      svgClass,
      switchClass,
      mapContainer,
      mapInnerContainer,
      popups,
      additionalFilter
    } = config;
    this.location = window.location.href.split('/');
    this.urlPart = urlPart;
    this.urlPartCategories = urlPartCategories;
    this.categoriesName = categoriesName;
    this.mapClass = mapClass;
    this.filterContainer = document.querySelector(filterContainer);
    this.svgElements = document.querySelectorAll(svgElements);
    this.filterTitelClass = `${filterTitelClass}`;
    this.mapTitle = mapTitle;
    this.mapInfo = mapInfo;
    this.tableHeadClass = tableHeadClass;
    this.tableContent = '';
    this.svgClass = svgClass;
    this.maps = [...document.querySelectorAll(svgClass)];
    this.switchClass = switchClass;
    this.switchs = [...document.querySelectorAll(switchClass)];
    this.activeClassName = 'active';
    this.lang = document.documentElement.getAttribute('lang');
    this.shortLang = this.lang.substring(0, this.lang.indexOf('-'));
    this.mapContainer = document.querySelector(mapContainer);
    this.mapInnerContainer = document.querySelector(mapInnerContainer);
    this.popups = document.querySelectorAll(popups);
    this.additionalFilter = document.querySelector(additionalFilter);
    this.element = '';
    this.filterElements = '';
    this.activeSwitch = '';
    this.swiperInstances = [];

    if (this.filterContainer) {
      this.bindEvents();
    }
  }

  bindEvents() {
    let locationarray = this.location.join('/').replace(/\/$/, '');

    this.restUrlCategories = `${locationarray}${this.urlPartCategories}?name=${this.categoriesName}`;
    this.mobileCenterMapHorizontally();

    this.getData(this.restUrlCategories).then((posts) => {
      posts.forEach((post) => {

        let catName = `${this.categoriesName}`;

        if ( post.name.toLowerCase() == catName.toLowerCase() ) {
          let categorieID = post.id;
          this.restUrl = `${locationarray}${this.urlPart}?categories=${categorieID}&lang=${this.shortLang}`;
          //get the post, which has the categorie-name for the map

          this.getData(this.restUrl).then((post) => {
            return post.map((element) => {
              this.element = element.content;
              setTimeout(this.filterMap(), 500);
              return element;
            });
          });
        }
      });
    });

    this.popups.forEach(popup => {
      popup.setAttribute('id', 'ns-map-popup__' + popup.querySelector('.ns-card__label').innerText.toLowerCase());
    });

    let popUpSlider =
      `<div class="ns-map-popup__wrapper js-map-popup-slider swiper-container">
        <div class="ns-map-popup__inner swiper-wrapper"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>`;

    this.mapInnerContainer.insertAdjacentHTML('beforeend', popUpSlider);

    let popupButtons = document.querySelectorAll('div[data-name=Deutschland-Projects] g[data-name^=Projekt_]');
    popupButtons.forEach(popupButton => {
      popupButton.addEventListener("click", e => {
        if(popupButton != null && popupButton.getAttribute('data-name')){
          let getPopup = popupButton.getAttribute('data-name').toLowerCase();
          getPopup = getPopup.replace('projekt_', 'ns-map-popup__');
          if(document.querySelector('#' + getPopup)){
            this.closePopup();
            document.querySelectorAll('#' + getPopup).forEach(popup => {
              let newPopup = popup.cloneNode(true);
              newPopup.setAttribute('id', newPopup.getAttribute('id') + '--clone');
              newPopup.classList.add('ns-map-popup__clone');
              newPopup.querySelector('.ns-card__arrow').addEventListener('click', e => {
                this.closePopup();
              });
              this.initSwiper('.swiper-container');
              document.querySelector('.ns-map-popup__inner').insertAdjacentElement('beforeend', newPopup);
            });
          }
        }
      });
    });

    this.switchs.forEach((el) => {
      el.addEventListener('input', (e) => {
        this.switchData(e.target.value);
        //when use switch, change the content of the svg to the first filter of active category (Deutschland/Europa)
        let firstButton = this.getFirstElementAfterSwitch(e.target.value);
        this.changeContentAndFilter(firstButton, this.tableContent, this.buttons);
        this.mobileCenterMapHorizontally();
      });
    });
  }

  filterMap(){
    this.filterElements = this.getFilterTitles(this.element); // get the filters from the tables head-class
    this.filterContainer.innerHTML = this.writeFilterTemplate(this.filterElements); //write the filter-html, add the filters to the filter-container
    this.tableContent = this.addClassesToSpanAndRow(this.element); //add the classes to the tables from the columns to compare them later with the id of the svg
    this.activeSwitch = document.querySelector(this.switchClass + ':checked');

    setTimeout(() => {
      this.filter = document.querySelectorAll('.filter-accordion');

      this.switchData(this.activeSwitch.value); //functionality to switch the svg map and the filters when use the toggler/switcher. Germany/Europa for example

      this.Accordion = new InteractiveMapAccordion({
        accordions: '.filter-accordion__wrap',
        accordionsTitel: '.filter-accordion__titel',
        accordionsContent: '.filter-accordion__content',
        accordionsWrapper: '.filter-accordion',
        pxCorrection: '10px'
      });

      this.buttons = document.querySelectorAll('.filter-accordion__button');
      this.bindLinks(this.buttons, this.tableContent); //add the functionality to the filter-buttons

      let firstButton = this.getFirstElementAfterSwitch(this.activeSwitch.value);
      this.changeContentAndFilter(firstButton, this.tableContent, this.buttons);

      this.bindProjects();
    }, 500);
  }

  mobileCenterMapHorizontally() {
    let svgElementWidth = 0;

    if(document.querySelector(`${this.svgClass}.${this.activeClassName}`)){
      let svgElementWidth = document.querySelector(`${this.svgClass}.${this.activeClassName}`).offsetWidth;
    }

    let containerWidth = this.mapContainer.offsetWidth;
    let scrollWidth = (svgElementWidth - containerWidth) / 2;
    this.mapContainer.scrollLeft = scrollWidth;
  }

  bindLinks(buttons, tableContent) {
    this.changeContentAndFilter(buttons[0], tableContent, buttons);

    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.closePopup();
        if(button.getAttribute('id').indexOf('de') == 0 && this.additionalFilter.classList.contains('active')){
          document.querySelectorAll('.interactive-map__svg-item').forEach(e => {e.classList.remove('active');});
          document.querySelector('.interactive-map__svg-item[data-name="Deutschland"]').classList.add('active');
          this.additionalFilter.classList.remove('active');
        }
        this.changeContentAndFilter(button, tableContent, buttons);
      });
    });
  }

  changeContentAndFilter(activeFilter, tableContent, allFilter) {
    if(activeFilter){
      this.changeSvgContent(activeFilter.id, tableContent);
      let mapTitle = document.querySelector(`${this.mapTitle}`);
      this.changeTitel(mapTitle, activeFilter, false);
      this.toggleButtonClass(allFilter, activeFilter);
    }
  }

  changeSvgContent(id, tableContent) {
    let allNumbersSpan = tableContent.querySelectorAll(`.${id}`);
    allNumbersSpan.forEach(span => {
      let sup = span.nextElementSibling ? `<tspan dy="-10" style="font-size: 50%;" dx="1">${span.nextElementSibling.innerHTML}</tspan>` : ``;
      this.changeSvgText(span, sup);
    });
  }

  changeTitel(title, el, info) {
    title.innerHTML = el.innerText;
    let infoText = document.querySelector(`${this.mapInfo}`);
    info ? infoText.style.visibility = "hidden" : infoText.style.visibility = "visible";
  }

  toggleButtonClass(elArray, singleEl) {
    elArray.forEach((element) => {
      //parent of filter gets a different color too, when active
      let parents = Helper.getParentNodeWithClass(element, 'filter-accordion__wrap');
      Helper.removeClass(element, this.activeClassName);
      Helper.removeClass(parents, this.activeClassName);

      let parentSingleEl = Helper.getParentNodeWithClass(singleEl, 'filter-accordion__wrap');
      Helper.addClass(singleEl, this.activeClassName);
      Helper.addClass(parentSingleEl, this.activeClassName);
    });
  }

  changeSvgText(el, sup) {
    let aria = el.getAttribute('data-area');
    let txt = el.innerHTML;
    if (aria) {
      this.svgElements.forEach((svgElement) => {
        let svgElementText = svgElement.querySelectorAll(`#${aria} text`);
        if (svgElementText && svgElementText.length > 0) {
          svgElementText.forEach((textEl)=>{
            textEl.innerHTML = txt + sup;
          });
        }
      });
    }
  }

  //take the content of the table, add class of id-column and put it on table row and as attribute to span to find and change text in svg
  addClassesToSpanAndRow(content) {
    let frag = document.createRange().createContextualFragment(content);
    let allIds = [...frag.querySelectorAll('.id')];
    allIds.forEach((el) => {
      let txt = el.innerHTML;
      let closestTr = Helper.getClosest(el, 'tr');
      if (txt) {
        closestTr.classList.add(txt);
        let closestSpan = closestTr.querySelectorAll('span');
        closestSpan.forEach((element) => {
          element.setAttribute('data-area', txt);
        });
      }
    });
    return frag;
  }

  getFilterTitles(content) {
    let frag = document.createRange().createContextualFragment(content);
    let map = [...frag.querySelectorAll(`${this.mapClass}`)];
    let mapArray = [];
    map.forEach((element) => {
      let spanArray = [];
      let tdHead = [...element.querySelectorAll(this.tableHeadClass)];
      tdHead.forEach((el) => {
        let span = el.querySelector('span');
        if (!!span && !span.classList.contains('id') && span.innerHTML !== '') {
          spanArray.push(span);
        }
      });
      mapArray.push(spanArray);
    });
    return mapArray;
  }

  writeFilterTemplate(elArray) {
    let htmlStuff = elArray.map((el, ind) => {
      let stringPart = '';
      let mapString = el.map((element, index) => {
        let sup = element.nextElementSibling ? element.nextElementSibling.outerHTML : '';
        switch (true) {
          case (element.classList.contains(this.filterTitelClass) && index === 0): //first element and title opens the loop
            stringPart = `<div class="filter-accordion__wrap" id="js-filter-accordion-${ind}-${index}">
                            <p class="filter-accordion__titel">${element.innerHTML}${sup}</p>
                            <div class="filter-accordion__content">`;
            break;
          case (element.classList.contains(this.filterTitelClass) && index > 0): //all title-elements close the element before and start a new one
            stringPart = `</div>
                        </div>
                        <div class="filter-accordion__wrap" id="js-filter-accordion-${ind}-${index}">
                          <p class="filter-accordion__titel">${element.innerHTML}${sup}</p>
                          <div class="filter-accordion__content">`;
            break;
          case (index === el.length - 1): //last element closes the block
            stringPart = `<div class="filter-accordion__innerElement"><button id="${element.classList}" class="filter-accordion__button">${element.innerHTML}${sup}</button></div>
                        </div>
                      </div>`
            break;
          default: //all filters inbetween the titles
            stringPart = `<div class="filter-accordion__innerElement"><button id="${element.classList}" class="filter-accordion__button">${element.innerHTML}${sup}</button></div>`
            break;
        }
        return stringPart;
      }).join('');

      return `<div class="filter-accordion js-map-filter-${ind}">${mapString}</div>`;
    });
    return htmlStuff.join('');
  }

  switchData(value = 0) {
    this.maps.forEach((element, index) => {
      Helper.removeClass(element, this.activeClassName);
      if (index == value) {
        Helper.addClass(element, this.activeClassName);
      }
    });

    this.filter.forEach((element, index) => {
      Helper.removeClass(element, this.activeClassName);
      if (index == value) {
        Helper.addClass(element, this.activeClassName);
      }
    });
  }

  getFirstElementAfterSwitch(value) {
    let firstButtonInContainer = '';
    this.filter.forEach((element, index) => {
      if (index == value) {
        let buttons = element.querySelectorAll('.filter-accordion__button');
        firstButtonInContainer = buttons[0];
      }
    });
    return firstButtonInContainer;
  }

  bindProjects(){
    document.querySelector('.js-map-filter-1').insertAdjacentElement('beforeend', this.additionalFilter); // special case
    this.additionalFilter.addEventListener("click", e => {
      document.querySelectorAll('.filter-accordion__wrap').forEach(e => {e.classList.remove('active');});
      document.querySelectorAll('.filter-accordion__button').forEach(e => {e.classList.remove('active');});
      document.querySelectorAll('.interactive-map__svg-item').forEach(e => {e.classList.remove('active');});
      this.additionalFilter.classList.add('active');
      document.querySelector('.interactive-map__svg-item[data-name="Deutschland-Projects"]').classList.add('active');
      let mapTitle = document.querySelector(`${this.mapTitle}`);
      this.changeTitel(mapTitle, this.additionalFilter, true);
    });
  }

  initSwiper(swiperContainer) {
    let swiperConfig = {};
    swiperConfig = {
      autoHeight: true,
      effect: 'fade',
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };
    const instance = new Swiper(swiperContainer, swiperConfig);
    this.swiperInstances.push(instance);
  }

  destroySwipers() {
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }

  getData(restUrl) {
    return fetch(restUrl, {
        headers: {
          'X-WP-Token': NSContext.token
        }
      })
      .then((response) => {
        return response.json();
      })
  }

  closePopup(){
    if(document.querySelector('.ns-map-popup__clone')){
      document.querySelectorAll('.ns-map-popup__clone').forEach(popup => popup.remove());
    }
  }
}
export default InteractiveMap;
